import type { FieldPath, FieldValues } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import { useAppDispatch } from "@/store/app/hooks";
import { updateFormState } from "../../store/slices/interaction/formStateSlice";
import { useEditedPaths } from "@/features/sparxsEditor/contexts/EditedPathsContext";

export interface UseEditorFieldStateOptions<TFieldValues extends FieldValues> {
  control?: ReturnType<typeof useFormContext<TFieldValues>>["control"];

  errorMessage?: string;
}

export const useEditorFieldState = <
  TFieldValues extends FieldValues = Record<string, unknown>,
>(
  name: string,
  options?: UseEditorFieldStateOptions<TFieldValues>,
) => {
  const {
    control: contextControl,
    formState,
    getFieldState,
  } = useFormContext<TFieldValues>();
  const control = options?.control ?? contextControl;
  const { error } = getFieldState(name as FieldPath<TFieldValues>, formState);
  const errorMessageToShow = error?.message ?? options?.errorMessage;
  const { isPathEdited } = useEditedPaths();
  const isEdited = isPathEdited(name);
  const dispatch = useAppDispatch();
  const dispatchUpdateFormState = (value: string) => {
    dispatch(updateFormState(value));
  };
  return {
    control,
    errorMessageToShow,
    isEdited,
    dispatchUpdateFormState,
  };
};
